//@flow
import {ButtonBase, makeStyles} from '@material-ui/core';
import {ArrowForwardIos} from '@material-ui/icons';
import React from 'react';
import {colors} from '../../../../assets/styles/colors';
import {classNames} from '../../../../utils/react';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: '.5rem',
    width: 'auto',
    borderRadius: '0.75rem',
    background: 'white',
    // minWidth: '280px',
    minWidth: 'fit-content',
    paddingInline: '1.5rem',
  },
  icon: {
    // width: '3.5rem',
    height: '3.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    flexShrink: 0,
    fontSize: '1.5rem',
    borderRadius: '0.65rem',

    '&[data-color="primary"]': {
      // background: `${colors.primary}29`,
      // color: colors.primary,
    },

    '&[data-color="success"]': {
      // background: `${colors.success}29`,
      // color: colors.success,
    },

    '&[data-color="danger"]': {
      // background: `${colors.error}29`,
      color: colors.error,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '.25rem',
    textAlign: 'left',
  },
  title: {
    color: colors.grey900,
    fontSize: '1rem',
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  subtitle: {
    color: colors.grey700,
    fontSize: '.85rem',
  },
  textDanger: {
    color: colors.error,
  },
}));

export type Props = {
  title: string,
  icon: React$Node,
  onClick: () => void,
  showRightArrow?: boolean,
  subtitle?: string,
  color?: 'primary' | 'success' | 'danger',
};

export default function BulkEditOptionItem(props: Props) {
  const {
    title,
    icon,
    onClick,
    showRightArrow,
    subtitle,
    color = 'primary',
  } = props;
  const classes = useStyles();

  return (
    <ButtonBase className={classes.root} onClick={onClick}>
      <span className={classes.icon} data-color={color}>
        {icon}
      </span>
      <div className={classes.content}>
        <span
          className={classNames(classes.title, {
            [classes.textDanger]: color === 'danger',
          })}
        >
          {title}
        </span>
        {subtitle && <span className={classes.subtitle}>{subtitle}</span>}
      </div>

      {showRightArrow && (
        <span className={classes.rightArrow}>
          <ArrowForwardIos />
        </span>
      )}
    </ButtonBase>
  );
}
